import { getVideoMetadata } from '../get-video-metadata';

type VideoMetadataGetter = (videoUrl: string, options: { timeout: number }) => Promise<{ aspectRatio: number }>;

export async function getCreationVideoAspectRatio({
  videoUrl,
  resolution,
  shouldProbeMetadata,
  getMetadata = getVideoMetadata,
}: {
  videoUrl: string;
  resolution?: { width?: number; height?: number };
  shouldProbeMetadata: boolean;
  getMetadata?: VideoMetadataGetter;
}): Promise<number | null> {
  if (resolution?.width && resolution.height) {
    return resolution.width / resolution.height;
  }

  if (!shouldProbeMetadata) return null;

  try {
    const metadata = await getMetadata(videoUrl, { timeout: 15000 });
    return metadata.aspectRatio;
  } catch (error) {
    console.error('fetchVideoMetadata error:', error);
    return null;
  }
}
